import Ad from 'src/components/ads/Ad';
import { ILoaderMoviesProps } from 'src/lib/types/filminfo/ILoaderMoviesProps';
import MonthlyMovies from 'src/components/kommendefilmer/MonthlyMovies';
import { isPremiereThisWeek } from 'src/components/kommendefilmer/helperFunctions';
import { parseISO } from "date-fns";
import { Movie } from 'src/lib/movieinfo/movieinfotypes';
import { groupBy } from 'lodash';
import React from 'react';

//#region [Props]
type MoviesByMonthProps = {
	adKeys: string[];
	showTextList?: boolean;
} & ILoaderMoviesProps;
//#endregion

//#region [Component]
export default function MoviesByMonth({ movies, adKeys, showTextList = false }: MoviesByMonthProps) {
	const _movies = movies?.filter(m => !isPremiereThisWeek(m));
	const groupedMovies = groupBy(_movies, grouper);
	const keys = Object.keys(groupedMovies).map(key => Number(key)).sort();
	let adIdx = 0;
	return keys.map(monthKey => {
		const movies = groupedMovies[monthKey.toString()];
		const shouldShowAd = (movies.length >= 7 && adIdx < adKeys.length);

		return <React.Fragment key={monthKey}>
			{shouldShowAd && <Ad targetId={adKeys[adIdx++]} removeIfNoAd supportsFixedAd height="300" mobileScreenWidth />}
			<MonthlyMovies monthKey={monthKey} movies={movies} showTextList={showTextList} />
		</React.Fragment>
	});
}
//#endregion

function grouper(movie: Movie): number {
	const d = parseISO(movie.premiere);
	return d.getFullYear() + ((d.getMonth() + 1) / 100.0);
}


//#region [Styles]

//#endregion